import type { Ref } from '@vue/composition-api';
import { ref } from '@vue/composition-api';
import Vue from 'vue';
import type { CommentHeight } from '../types/comment';

export function useCommentsHeightsCalculator() {
  const commentsHeights: Ref<CommentHeight> = ref({});

  const addHeight = ({ commentId, height }) => {
    Vue.set(commentsHeights.value, commentId, height);
  };

  const resetCommentsHeights = () => {
    commentsHeights.value = {};
  };

  return { addHeight, resetCommentsHeights, commentsHeights };
}
